import { useCallback } from 'react';

import { fetchConfigurationAnonymous } from '../data-access';

export const usePrivacyPolicy = () => {
	return useCallback(
		async (
			locale: string
		): Promise<{
			contactUsLink?: string;
			privacyPolicyLink?: string;
		}> => {
			const response = await fetchConfigurationAnonymous(locale);

			return {
				contactUsLink: response?.contactUsHereLinkForUsaCapsicum,
				privacyPolicyLink: response?.privacyPolicyLink
			};
		},
		[]
	);
};
